import { styled, Box, Typography, TextField, Button } from "@mui/material";
import colors from "../../theme/Colours";

export const SummaryContainer = styled(Box)(({ theme }) => ({
  boxShadow: "none",
  border: "none",
  backgroundColor: "#fff",
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

export const SummaryTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "1.25rem",
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.1rem",
  },
}));

export const SummaryRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: theme.spacing(0.5),
}));

export const SummaryLabel = styled(Typography)(({ theme }) => ({
  color: colors.greyTextColor,
  fontWeight: 400,
  fontSize: "1rem",
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.9rem",
  },
}));

export const SummaryValue = styled(Typography)(({ theme }) => ({
  color: "#50B83C",
  fontWeight: 700,
  fontFamily: "Roboto",
  fontSize: "0.9rem",
  textAlign: "right",
  whiteSpace: "nowrap",
  flexShrink: 0,
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.8rem",
  },
}));

export const TotalLabel = styled(Typography)({
  fontWeight: "bold",
});

export const NoteField = styled(TextField)(({ theme }) => ({
  backgroundColor: "white",
  height: "100%",
  minHeight: 200,
  marginTop: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    minHeight: 150,
  },
}));

export const PlaceOrderButton = styled(Button)(({ theme }) => ({
  backgroundColor: colors.primaryButtonOrange,
  color: "white",
  borderRadius: 1,
  marginTop: theme.spacing(8),
  padding: theme.spacing(1.5),
  fontSize: "0.9rem",
  "&:hover": {
    backgroundColor: colors.primaryButtonOrangeHover,
  },
  [theme.breakpoints.down("sm")]: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    fontSize: "0.8rem",
  },
}));

export const ButtonIcon = styled("img")(({ theme }) => ({
  marginRight: theme.spacing(1),
  width: 20,
  [theme.breakpoints.down("sm")]: {
    width: 16,
  },
}));
